import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  filterPaper: {
    color: theme.palette.text.secondary,
    padding: theme.spacing(1.5),
  },
  formControl: {
    margin: theme.spacing(1),
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  centerAlign: {
    textAlign: "center",
  },
  searchButton: {
    textTransform: "capitalize",
  },
  clearFilter: {
    backgroundColor: "rgba(0,0,0,0.05)",
    textTransform: "capitalize",
  },
  toolbar: theme.mixins.toolbar,
  card: {
    margin: "15px",
    transition: "transform .2s",
    boxShadow: "0 14px 28px rgba(0,0,0,0.25), 0 5px 5px rgba(0,0,0,0.22)",
    "&:hover": {
      transform: "scale(1.2)",
    },
  },
}));

export default useStyles;
